
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzyAq", function(module, exports) {
function $ccb088b450e70795$var$close_all_modals() {
    modal_forms.style.display = "none";
    modal_about.style.display = "none";
}
function $ccb088b450e70795$var$init() {
    const header_forms = document.getElementById("header_forms");
    const header_about = document.getElementById("header_about");
    const modal_forms1 = document.getElementById("modal_forms");
    const modal_about1 = document.getElementById("modal_about");
    const close_modals = document.getElementsByClassName("close_modal");
    const menu_icon = document.getElementsByClassName("menu_icon")[0];
    const details = document.getElementsByTagName("details");
    const header = document.getElementsByTagName("header")[0];
    const update_time = document.getElementById("update_time");
    menu_icon.addEventListener("click", ()=>{
        if (header.dataset.expanded == "true") header.dataset.expanded = "false";
        else header.dataset.expanded = "true";
    });
    for(let idx = 0; idx < close_modals.length; idx++)close_modals.item(idx).addEventListener("click", (evt)=>evt.target.parentElement.parentElement.style.display = "none");
    header_forms.addEventListener("click", ()=>{
        modal_about1.style.display = "none";
        modal_forms1.style.display = "flex";
        header.dataset.expanded = "false";
    });
    header_about.addEventListener("click", ()=>{
        modal_forms1.style.display = "none";
        modal_about1.style.display = "flex";
        header.dataset.expanded = "false";
    });
    document.body.addEventListener("keyup", (evt)=>{
        if (evt.key == "Escape" || evt.key == "Esc") $ccb088b450e70795$var$close_all_modals();
    }, true);
    window.addEventListener("beforeprint", ()=>{
        for(let idx = 0; idx < details.length; idx++)details.item(idx).setAttribute("open", "true");
    });
    window.addEventListener("afterprint", ()=>{
        for(let idx = 0; idx < details.length; idx++)details.item(idx).removeAttribute("open");
    });
    let modified_date = new Date(document.lastModified);
    update_time.innerText = modified_date.getMonth() + 1 + "/" + modified_date.getDate() + "/" + modified_date.getFullYear();
}
window.addEventListener("DOMContentLoaded", $ccb088b450e70795$var$init);

});

parcelRegister("7Lwo3", function(module, exports) {
function $5a760b8feaa5d3bd$var$analytics_ignore() {
    return localStorage.getItem("analytics-ignore") == "true" || false;
}
function $5a760b8feaa5d3bd$var$analytics_setup() {
    let site_loaded = sessionStorage["siteloaded"] == "true";
    let first_time = localStorage["notfirst"] != "true";
    sessionStorage["siteloaded"] = "true";
    localStorage["notfirst"] = "true";
    let mobile = undefined, browser = "Unknown", browser_version = "Unknown", system = "Unknown", language = navigator.language || "Unknown";
    if (navigator.userAgentData) {
        mobile = navigator.userAgentData.mobile;
        system = navigator.userAgentData.platform;
        for (let brand of navigator.userAgentData.brands)if (brand.brand != "Not-A.Brand" && brand.brand != "Not.A/Brand") {
            if (browser == "Unknown") browser = "";
            if (browser_version == "Unknown") browser_version = "";
            browser += brand.brand + " / ";
            browser_version += brand.version + " / ";
        }
        if (browser != "Unknown") browser = browser.substring(0, browser.length - 3);
        if (browser_version != "Unknown") browser_version = browser_version.substring(0, browser_version.length - 3);
    } else {
        if (navigator.userAgent && navigator.userAgent.toLowerCase().includes("firefox") || "netscape" in window && / rv:/.test(navigator.userAgent)) {
            browser = "Firefox";
            let match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);
            if (match) browser_version = match[1];
            else {
                match = window.navigator.userAgent.match(/rv:\/([0-9]+)\./);
                if (match) browser_version = match[1];
            }
        } else if (navigator.vendor && navigator.vendor.toLowerCase().indexOf("apple") > -1 || navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("safari") > -1 && navigator.userAgent.indexOf("CriOS") == -1 && navigator.userAgent.indexOf("FxiOS") == -1) {
            browser = "Safari";
            let match = window.navigator.userAgent.match(/Version\/([0-9]+)\./);
            if (match) browser_version = match[1];
        }
        if (navigator.userAgent.toLowerCase().includes("crios")) {
            browser = "Chrome";
            system = "iOS";
            let match = window.navigator.userAgent.match(/CriOS\/([0-9]+)\./);
            if (match) browser_version = match[1];
        }
        if (navigator.userAgent.toLowerCase().includes("fxios")) {
            browser = "Firefox";
            system = "iOS";
            let match = window.navigator.userAgent.match(/FxiOS\/([0-9]+)\./);
            if (match) browser_version = match[1];
        }
    }
    if (navigator.userAgent && (system == "Unknown" || system == "")) {
        if (navigator.userAgent.toLowerCase().includes("iphone")) system = "iOS";
        else if (navigator.userAgent.toLowerCase().includes("mac")) system = "macOS";
        if (navigator.userAgent.toLowerCase().includes("windows")) system = "Windows";
        if (navigator.userAgent.toLowerCase().includes("cros")) system = "ChromeOS";
        if (navigator.userAgent.toLowerCase().includes("android")) system = "Android";
        if (navigator.userAgent.toLowerCase().includes("linux")) system = "Linux";
    }
    if (system == "iOS") mobile = true;
    if ($5a760b8feaa5d3bd$var$analytics_ignore()) document.getElementById("analytics_ignore").style.display = "block";
    analytics_record_event("page_load", {
        page: window.location.href,
        subpage: window.location.pathname.substring(1),
        referrer: document.referrer != "" ? document.referrer : undefined,
        page_width: window.innerWidth,
        page_height: window.innerHeight,
        // I got 2400.037623167038 for the height because the device pixel ratio was some 15-digit float... cast that to an int!
        screen_width: Math.round(Number.parseFloat(window.screen.width * window.devicePixelRatio)),
        screen_height: Math.round(Number.parseFloat(window.screen.height * window.devicePixelRatio)),
        screen_resolution: `${Math.round(Number.parseFloat(window.screen.width * window.devicePixelRatio))}x${Math.round(Number.parseFloat(window.screen.height * window.devicePixelRatio))}`,
        mobile: mobile,
        browser: browser,
        browser_version: browser_version,
        os: system,
        language: language,
        first_visit: first_time,
        first_page_load: !site_loaded // first load this session
    });
}
//                             string, object
window.analytics_record_event = (event, data = {})=>{
    const analytics_url = "https://script.google.com/macros/s/AKfycbzF4_BL8fYMyn1HwoCjuH4dsIO5pSenne7zOn-9XY_QqEej6oIpIkp1G84rXlTFdrYlhA/exec";
    let data_str = `${$5a760b8feaa5d3bd$var$analytics_ignore() ? "&coordinator=true" : ""}&millis_since_epoch=${new Date().getTime()}&host=${window.location.host}`;
    for (let datakey of Object.keys(data))if (data[datakey] != undefined) data_str += `&${datakey.toString().replaceAll(" ", "%20")}=${data[datakey].toString().replaceAll(" ", "%20")}`;
    let http_req = new XMLHttpRequest();
    http_req.open("GET", `${analytics_url}?event=${event.toString().replaceAll(" ", "%20")}${data_str}`);
    http_req.send();
};
if (document.readyState != "loading") $5a760b8feaa5d3bd$var$analytics_setup();
else document.addEventListener("DOMContentLoaded", $5a760b8feaa5d3bd$var$analytics_setup);

});

parcelRequire("hzyAq");
parcelRequire("7Lwo3");
function $0669b77acdb075f9$var$get_volunteer_opps(callback) {
    let http_req = new XMLHttpRequest();
    http_req.onreadystatechange = ()=>{
        if (http_req.readyState === 4) try {
            callback(JSON.parse(http_req.response));
        } catch (err) {
            callback([]);
            console.warn("JSON parse error:");
            console.error(err);
            document.getElementById("volunteer_opportunities_sidebar").innerHTML += '<div class="center"><h4>There was a problem fetching volunteer opportunities.</h4>';
            document.getElementById("volunteer_opportunities_sidebar").innerHTML += "<h6>Please check your network connection and try again.</h6></div>";
            document.getElementsByClassName("fingerprint-spinner")[0].remove();
        }
    };
    http_req.open("GET", "https://script.google.com/macros/s/AKfycbzjWak70BnkDwcesixlFtf7Vpavxag3Ys4PGm3oyOE1ev-No-rm7dZGGsXx6DDE6tA/exec");
    http_req.send();
}
function $0669b77acdb075f9$var$sort_by_date(list) {
    list.sort(function(first, second) {
        return new Date(first) - new Date(second);
    });
    return list;
}
function $0669b77acdb075f9$var$get_opp_element_html(opp) {
    const WEEKDAYS = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    let datestr = "Ongoing opportunity";
    if (opp["date"] != "Ongoing") {
        if (opp["date"].toString().indexOf("=") >= 0) {
            let dates = opp["date"].split("=");
            let date1 = new Date(dates[0]);
            let date2 = new Date(dates[1]);
            datestr = `${WEEKDAYS[date1.getDay()]} ${date1.getMonth() + 1}/${date1.getDate()}/${date1.getFullYear()} - ${WEEKDAYS[date2.getDay()]} ${date2.getMonth() + 1}/${date2.getDate()}/${date2.getFullYear()}`;
        } else if (opp["date"].toString().indexOf(",") >= 0) {
            let dates = $0669b77acdb075f9$var$sort_by_date(opp["date"].split(","));
            datestr = "";
            for (let date of dates){
                date = new Date(date);
                if (!$0669b77acdb075f9$var$is_date_in_past(date)) datestr += `${WEEKDAYS[date.getDay()]} ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}, `;
            }
            datestr = datestr.substring(0, datestr.length - 2);
        } else {
            let date = new Date(opp["date"]);
            datestr = `${WEEKDAYS[date.getDay()]} ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        }
    }
    let html = `<div class="sidebar_element structured_sidebar_element">
		<p class="sse_item title">${opp["name"]}</p>
		<!-- <p class="sse_item organization">${opp["org"]}</p> -->
		<p class="sse_item location"><a href="https://www.google.com/maps?q=${opp["location"].replaceAll(" ", "+")}" target="blank">${opp["location"]}</a></p>
		<hr>
		<p class="sse_item daterange">${datestr}</p>`;
    if (opp["link"] != "") html += `<p class="sse_item link"><a target="_blank" onclick="analytics_record_event('service_opportunity_clicked', { opportunity_name: '${opp["name"]}', opportunity_url: '${opp["link"]}' });" href="${opp["link"].replaceAll("javascript:", "")}">${opp["link"].replace("http://", "").replace("https://", "").replace("www.", "").replace("mailto:", "").replace("tel:", "").replaceAll("javascript:", "")}</a></p>`;
    else html += `<p class="sse_item link"><a target="_blank" onclick="analytics_record_event('service_opportunity_clicked', { opportunity_name: '${opp["name"]}', opportunity_url: '${opp["email"]}' });" href="mailto:${opp["email"]}">Contact ${opp["email"]}</a></p>`;
    // html += `<p class="sse_item email">Contact: ${opp["contact"]} (<a class="break_all" href="mailto:${opp["email"]}">${opp["email"]}</a>)</p>`
    if (opp["more_info"] != "") html += `<p class="sse_item info">Additional Info: ${opp["more_info"]}</p>`;
    html += `</div>`;
    return html;
}
function $0669b77acdb075f9$var$is_date_in_past(date) {
    let now = new Date();
    date.setHours(23, 59, 59);
    return date < now;
}
window.addEventListener("DOMContentLoaded", ()=>{
    $0669b77acdb075f9$var$get_volunteer_opps((opps)=>{
        opps.sort(function(first, second) {
            // If dates are ongoing they should be last
            if (first["date"] == "Ongoing" && second["date"] == "Ongoing") return 0;
            if (first["date"] == "Ongoing") return 1;
            if (second["date"] == "Ongoing") return -1;
            // Here so that when we use the date later, it isn't the changed date.
            // If we have a date range, the date range should still be present in `get_opp_element_html`
            // rather than the first date, like we set it lower.
            let first_date = first["date"];
            let second_date = second["date"];
            let first_date_object = new Date();
            let second_date_object = new Date();
            // For each date, if the start date has already passed sort by the end date, otherwise sort by the start date
            // If it doesn't have a start / end date, sort by the date given.
            function get_date_object(date_string) {
                let date_string_object = new Date();
                if (date_string.indexOf("=") > -1) {
                    let split_date_string = date_string.split("=");
                    if (!$0669b77acdb075f9$var$is_date_in_past(new Date(split_date_string[0]))) date_string_object = new Date(split_date_string[0]);
                    else date_string_object = new Date(split_date_string[1]);
                } else if (date_string.indexOf(",") > -1) {
                    // This should get the first one not in the past, or the first one period
                    let split_date_string = $0669b77acdb075f9$var$sort_by_date(date_string.split(","));
                    let date_idx = 0;
                    while($0669b77acdb075f9$var$is_date_in_past(new Date(split_date_string[date_idx])))date_idx++;
                    date_string_object = new Date(split_date_string[date_idx]);
                } else date_string_object = new Date(date_string);
                return date_string_object;
            }
            first_date_object = get_date_object(first_date);
            second_date_object = get_date_object(second_date);
            return first_date_object - second_date_object;
        });
        for (let opp of opps)document.getElementById("volunteer_opportunities_sidebar").innerHTML += $0669b77acdb075f9$var$get_opp_element_html(opp);
        document.getElementsByClassName("fingerprint-spinner")[0].remove();
    });
    // TEMP: Medal list recipients
    // TODO: Consolidate this and the medal-list.html scripts
    function title_case(str) {
        let outstr = "";
        let lastchar = undefined;
        for (let char of str){
            if (!lastchar || lastchar == "-" || lastchar == " ") outstr += char.toUpperCase();
            else outstr += char.toLowerCase();
            lastchar = char;
        }
        return outstr;
    }
    const fetch_controller = new AbortController();
    const signal = fetch_controller.signal;
    // https://stackoverflow.com/a/12646864
    const shuffle = (array)=>{
        for(let i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [
                array[j],
                array[i]
            ];
        }
    };
    fetch("resources/MedalList.25-26.txt", {
        signal: signal
    }).then((response)=>{
        return response.text();
    }).then((medal_list)=>{
        let names = medal_list.replaceAll("\r", "").replaceAll("	", " ").split("\n");
        for(let idx = 0; idx < names.length; idx++)names[idx] = title_case(names[idx]);
        let medal_list_name = document.getElementById("medal_list_name");
        const characters = "ABCDEFGHIJKLMNOPQRSTUVQXYZ";
        const get_random_string = (length = 5)=>{
            let str = "";
            str += characters.toUpperCase()[Number.parseInt(Math.random() * characters.length)];
            for(let idx = 1; idx < length - 2; idx++)str += characters.toLowerCase()[Number.parseInt(Math.random() * characters.length)];
            str += " ";
            str += characters.toUpperCase()[Number.parseInt(Math.random() * characters.length)];
            return str;
        };
        const interval = 50;
        let random_count = 0;
        let pause_count = 2500;
        let pause_left = 0;
        let nextname = names[Number.parseInt(Math.random() * names.length)];
        setInterval(()=>{
            if (pause_left >= 0) pause_left -= interval;
            else if (random_count >= 0) {
                medal_list_name.innerText = get_random_string(nextname.length);
                random_count--;
            } else {
                medal_list_name.innerText = nextname;
                nextname = names[Number.parseInt(Math.random() * names.length)];
                pause_left = pause_count;
                random_count = 5;
            }
        }, interval);
    }).catch((error)=>{
        console.error("Medal list error:", error);
    });
});


//# sourceMappingURL=index.ea8a725b.js.map
